import type EmailAddressWrapper from "owa-service/lib/contract/EmailAddressWrapper";
import type MeetingMessage from "owa-service/lib/contract/MeetingMessage";

export function isMeetingSentOnBehalfOf(message: MeetingMessage): boolean {
    const fromAddress = message.From?.Mailbox?.EmailAddress;
    const senderAddress = message.Sender?.Mailbox?.EmailAddress;
    
    return !!(!message.IsDraft &&
        fromAddress &&
        senderAddress &&
        fromAddress.toLowerCase() !== senderAddress.toLowerCase());
}

export function getMeetingDelegatedMailbox(message: MeetingMessage): EmailAddressWrapper | undefined {
    return message.IsDelegated ? message.ReceivedRepresenting?.Mailbox : undefined;
}

export function isMeetingDelegated(message: MeetingMessage): boolean {
    return !!message.IsDelegated && !!message.ReceivedRepresenting;
}
